// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JYhw","label":"styles_label__U5Ti0"};